"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useRouteName = useRouteName;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _routerContext = require("./router-context");
var _ = require(".");
// This needs to be a function so that we can use codegen to provide better
// types in a user's project (see web-routerRoutes.d.ts)
/** Gets the name of the current route (as defined in your Routes file) */
function useRouteName() {
  const routerState = (0, _routerContext.useRouterState)();
  const routeName = routerState.activeRouteName;
  if (isAvailableRouteName(routeName)) {
    return routeName;
  }
  return undefined;
}
function isAvailableRouteName(name) {
  var _context;
  return typeof name === 'string' && (0, _includes.default)(_context = (0, _keys.default)(_.routes)).call(_context, name);
}